<template>
  <div>
    <my-popup
      title="插入短链接网址"
      width="582"
      :zIndex="zIndex"
      :flag="insertShortUrlShow"
      @close="cancel"
    >
      <div class="tab-line">
        <!-- <div
          class="tab-item"
          :style="{
            color: switchType == '0' ? globalBG : '',
            'background-color': switchType == '0' ? '#FFF4F4' : '',
            'border-color': switchType == '0' ? globalBG : '',
          }"
          @click="switchTab('0')"
        >
          网址
        </div> -->
        <div
          class="tab-item"
          :style="{
            color: switchType == '4' ? globalBG : '',
            'background-color': switchType == '4' ? '#FFF4F4' : '',
            'border-color': switchType == '4' ? globalBG : '',
          }"
          @click="switchTab('4')"
        >
        自定义链接
        </div>
        <div
          class="tab-item"
          :style="{
            color: switchType == '1' ? globalBG : '',
            'background-color': switchType == '1' ? '#FFF4F4' : '',
            'border-color': switchType == '1' ? globalBG : '',
          }"
          @click="switchTab('1')"
        >
          店铺首页
        </div>
        <div
          class="tab-item"
          :style="{
            color: switchType == '2' ? globalBG : '',
            'background-color': switchType == '2' ? '#FFF4F4' : '',
            'border-color': switchType == '2' ? globalBG : '',
          }"
          @click="switchTab('2')"
        >
          商品链接
        </div>
        <div
          class="tab-item"
          :style="{
            color: switchType == '3' ? globalBG : '',
            'background-color': switchType == '3' ? '#FFF4F4' : '',
            'border-color': switchType == '3' ? globalBG : '',
          }"
          @click="switchTab('3')"
        >
          优惠券
        </div>
      </div>
      <div class="insertBox" v-if="switchType == 0">
        <div class="inser">
          <span>网址：</span>
          <el-input
            v-model="insertUrlValue"
            :placeholder="
              typeSms != '3' ? '仅支持手机端京东域名链接，如m.jd;' : ''
            "
            style="width: 480px"
          ></el-input>
        </div>
        <div class="tip_box" v-if="typeSms != 3">
          <img
            src="@/assets/images/new_icon_reminder.png"
            style="
              display: inline-block;
              float: left;
              position: absolute;
              width: 14px;
              height: 14px;
              color: #ffffff;
              margin: 3px 4px 0 -10px;
            "
          />
          <div>
            （1）仅支持手机端京东域名链接，如m.jd，且短信中只能插入一条短链；
          </div>
          <div>（2）默认短链前后添加空格，不可删除，保证点击跳转正常；</div>
          <div>
            （3）手机端京东其它活动页面（如开卡页面）需打开APP请使用“其它页面”功能进行转短网址。
          </div>
        </div>
        <div class="tip_box" v-else>
          <img
            src="@/assets/images/new_icon_reminder.png"
            style="
              display: inline-block;
              float: left;
              position: absolute;
              width: 14px;
              height: 14px;
              color: #ffffff;
              margin: 3px 4px 0 -10px;
            "
          />
          <div>
            手机端京东其它活动页面（如开卡页面）需打开APP请使用“其它页面”功能进行转短网址。
          </div>
        </div>
        <el-button
          class="cancelBtn"
          type="text"
          @click="cancel"
          v-if="typeSms != '3'"
          >取消</el-button
        >
        <el-button
          class="createUrlBtn right-dis"
          v-loading="shortLoading"
          @click="insertUrlChange(1, true)"
          v-if="typeSms == 3"
        >
          极短链接
        </el-button>
        <el-button
          class="createUrlBtn"
          v-loading="loading"
          @click="insertUrlChange(1)"
        >
          {{ typeSms == "3" ? "智能网址" : "确定" }}
        </el-button>
      </div>
      <div class="insertBox" v-if="switchType == 1">
        <div class="inser">
          <span style="width: 42px">网址：</span>
          <el-input
            v-model="shopHomeUrl"
            placeholder="仅支持手机端京东域名链接，如m.jd"
            style="width: 480px"
          ></el-input>
        </div>
        <div class="tip_box">
          <img
            src="@/assets/images/new_icon_reminder.png"
            style="
              display: inline-block;
              float: left;
              position: absolute;
              width: 14px;
              height: 14px;
              color: #ffffff;
              margin: 3px 4px 0 -17px;
            "
          />
          <div>跳转京东APP</div>
        </div>
        <el-button
          class="cancelBtn"
          type="text"
          @click="cancel"
          v-if="typeSms != '3'"
          >取消</el-button
        >
        <el-button
          class="createUrlBtn right-dis"
          v-loading="shortLoading"
          @click="insertUrlChange(2, true)"
          v-if="typeSms == 3"
        >
          极短链接
        </el-button>
        <el-button
          class="createUrlBtn"
          v-loading="loading"
          @click="insertUrlChange(2)"
        >
          {{ typeSms == "3" ? "智能网址" : "确定" }}
        </el-button>
      </div>
      <div class="insertBox" v-if="switchType == 2">
        <div class="inser">
          <span style="width: 80px">SKU ID：</span>
          <!-- <el-input oninput="value=value.replace(/^\.+|[^\d.]/g,'')" v-model="insertUrlValue2" placeholder="请输入商品SKU ID" style="width: 480px;"></el-input> -->
          <!-- oninput="value=value.replace(/^\.+|[^\d]/g,'')" -->
          <el-input
            v-model="insertUrlValue2"
            @input="onSku"
            placeholder="请输入商品SKU ID"
            style="width: 480px"
          ></el-input>
        </div>
        <div class="tip_box">
          <img
            src="@/assets/images/new_icon_reminder.png"
            style="
              display: inline-block;
              float: left;
              position: absolute;
              width: 14px;
              height: 14px;
              color: #ffffff;
              margin: 3px 4px 0 -17px;
            "
          />
          <div>跳转京东APP</div>
        </div>
        <el-button
          class="cancelBtn"
          type="text"
          @click="cancel"
          v-if="typeSms != '3'"
          >取消</el-button
        >
        <el-button
          class="createUrlBtn right-dis"
          v-loading="shortLoading"
          @click="insertUrlChange(3, true)"
          v-if="typeSms == 3"
        >
          极短链接
        </el-button>
        <el-button
          class="createUrlBtn"
          v-loading="loading"
          @click="insertUrlChange(3)"
        >
          {{ typeSms == "3" ? "智能网址" : "确定" }}
        </el-button>
      </div>
      <div class="insertBox" v-if="switchType == 3">
        <div class="insert">
          <div class="insert-name">优惠券地址：</div>
          <div class="insert-value">
            <el-button
              type="primary"
              @click="insertCouponShow = true"
              style="margin-bottom: 16px"
              :style="{ 'background-color': globalBG }"
              >选择优惠券</el-button
            >
            <el-input
              v-model="insertCouponValue"
              type="textarea"
              rows="4"
              placeholder="请选择优惠券"
              style="width: 430px"
            ></el-input>
          </div>
        </div>
        <el-button
          class="cancelBtn"
          type="text"
          @click="cancel"
          v-if="typeSms != '3'"
          >取消</el-button
        >
        <el-button
          class="createUrlBtn right-dis"
          v-loading="shortLoading"
          @click="insertUrlChange(4, true)"
          v-if="typeSms == 3"
        >
          极短链接
        </el-button>
        <el-button
          class="createUrlBtn"
          v-loading="loading"
          @click="insertUrlChange(4)"
        >
          {{ typeSms == "3" ? "智能网址" : "确定" }}
        </el-button>
      </div>
      <div class="insertBox" v-if="switchType == 4">
        <div class="insertLink">
          <div style="display: flex;">
            <div>网址：</div>
            <el-input type="textarea" v-model="insertUrlValue3" :placeholder="typeSms != '3' ? '请输入http://开头的链接' : ''"></el-input>
          </div>
          <div class="short-bottom">
            <el-button type="tetx" class="edit_btn" :underline="false" @click="openLink">保存链接</el-button>
            <el-button type="tetx" class="edit_btn"  style="margin-left: 24px;" :underline="false" @click="selectLink">选择链接</el-button>
          </div>
        </div>
        <div class="tip_box" v-if="typeSms != 3">
          <img
            src="@/assets/images/new_icon_reminder.png"
            style="
              display: inline-block;
              float: left;
              position: absolute;
              width: 14px;
              height: 14px;
              color: #ffffff;
              margin: 3px 4px 0 -10px;
            "
          />
          <div>
            （1）仅支持手机端京东域名链接，如m.jd，且短信中只能插入一条短链；
          </div>
          <div>（2）默认短链前后添加空格，不可删除，保证点击跳转正常。</div>
          <div>（3）仅京东主站的链接支持生成唤起app的短链（短链及前后空格占17字），即含item.m.jd.com、shop.m.jd.com、shopmember.m.jd.com；其它链接不能被唤起（短链及前后空格占15字），比如小程序、H5、优惠券等</div>
        </div>
        <div v-if="typeSms == 3">
          <div class="tip_box">
            <img
              src="@/assets/images/new_icon_reminder.png"
              style="
                display: inline-block;
                float: left;
                position: absolute;
                width: 14px;
                height: 14px;
                color: #ffffff;
                margin: 3px 4px 0 -10px;
              "
            />
            <div>跳转京东APP</div>
          </div>
        </div>
        <el-button
          class="cancelBtn"
          type="text"
          @click="cancel"
          v-if="typeSms != '3'"
          >取消</el-button
        >
        <el-button
          class="createUrlBtn right-dis"
          v-loading="shortLoading"
          @click="insertUrlChange(5, true)"
          v-if="typeSms == 3"
        >
          极短链接
        </el-button>
        <el-button
          class="createUrlBtn"
          v-loading="loading"
          @click="insertUrlChange(5)"
        >
          {{ typeSms == "3" ? "智能网址" : "确定" }}
        </el-button>
      </div>
    </my-popup>

    <!-- 插入优惠券链接 -->
    <insert-coupon-link
      v-if="insertCouponShow"
      :isShow="insertCouponShow"
      @close="insertCouponChange"
    ></insert-coupon-link>
    <!-- 保存链接弹窗 -->
    <my-popup
      title=""
      width="600"
      zIndex="9999"
      :flag="openDialogVisible"
      @close="handleClose"
    >
    <!-- <el-dialog
      :visible.sync="openDialogVisible"
      width="30%"
      :before-close="handleClose"
      style="z-index: 999999 !important;"
      > -->
      <el-form :model="form" label-width="100px" :rules="rules" ref="ruleForm" style="margin-top: 20px;" class="new-input-box" v-loading="saveLoading">
        <el-form-item label="链接名称：" prop="name">
          <el-input  
            type="text"
            placeholder=""
            maxlength="20"
            show-word-limit 
            v-model="form.name" 
            >
          </el-input>
        </el-form-item>
      </el-form>
      <div style="display: flex;justify-content: flex-end;">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" style="margin-left: 8px;" @click.native="handleConfirm">确 定</el-button>
      </div>
    <!-- </el-dialog> -->
    </my-popup>
    <!-- 选择链接弹窗 -->
    <link-select 
    :selectDialogVisible="selectDialogVisible"
    @selectLink="selectLinkFn"
    @close="selectDialogVisible =false"
    v-if="selectDialogVisible"
    ></link-select>
  </div>
</template>
<script>
import myPopup from "@/components/myPopup";
import insertCouponLink from "@/views/serviceCenter/insert_coupon_link";
import { getShortLink,saveLink } from "@/api/marketing/shortLink";
import { mapState } from "vuex";
import linkSelect from "@/components/LinkSelect.vue";
export default {
  // 插入短网址弹窗
  name: "",
  components: {
    myPopup,
    insertCouponLink,
    linkSelect
  },
  props: {
    typeSms: {
      type: Number,
      default: 1, // 1.表示智能营销 2.官方发送， 3.平台发送
    },
    strategyInstId: {
      type: String,
      default: "",
    },
    zIndex: {
      type: String,
      default: "99",
    },
  },
  data() {
    return {
      saveLoading: false,
      selectDialogVisible: false,
      rules: {
        name:[{ required: true, message: '请填写链接名称', trigger: 'blur' }]
      },
      form: {
        name: "",
      },
      openDialogVisible: false,
      // zIndex: '9000',
      insertShortUrlShow: true, // 插入短链接状态控制 ----- 内容
      insertUrlValue: null, // 插入网址
      insertUrlValue2: null, // 商品链接
      insertUrlValue3: null, // 其他页面
      // shopHomeUrl: 'https://mall.jd.com/index-10094518.html', // 店铺首页
      shopHomeUrl:
        "https://shop.m.jd.com/?shopId=" +
        this.$store.getters.loginUserInfo.shopId, // 店铺首页
      insertCouponValue: "", // 插入的优惠券地址

      switchType: 4,
      insertCouponShow: false, // 插入优惠券链接控制
      loading: false,
      shortLoading: false, // 极短链接
    };
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
      //   把city映射给currentCIty
    }),
  },
  mounted() {
    this.show = true;
    console.log("this.zIndex:", this.zIndex);
    console.log("typeSms:", this.typeSms);
  },
  methods: {
    selectLinkFn(item) {
      this.insertUrlValue3 = item.link
    },
    selectLink() {
      this.selectDialogVisible = true
    },
    handleClose() {
      this.$refs.ruleForm.clearValidate("name")
      this.openDialogVisible = false
    },
    handleConfirm() {
      this.$refs.ruleForm.validate(async(valid)=>{
        if(valid) {
          try {
            this.saveLoading = true
            let params = {
              name: this.form.name,
              link: this.insertUrlValue3
            }
            const res = await saveLink(params)
            if(res.code==1) {
              this.saveLoading = false
              this.$message.success("保存成功！")
              this.openDialogVisible = false
            }
          } catch (error) {
            this.saveLoading = false
          }
        }
      })
    },
    openLink() {
      if(!this.insertUrlValue3) {
        return this.$message.warning("请输入网址后保存")
      }
      this.form.name = ""
      this.openDialogVisible = true
    },
    onSku(val) {
      // console.log(val);
      // console.log(val.replace(/^\.+|[^\d]/g,''));
      this.insertUrlValue2 = val.replace(/^\.+|[^\d]/g, "");
    },
    cancel() {
      // this.insertShortUrlShow = false;
      this.$emit("close", false);
    },
    switchTab(index) {
      this.switchType = index;
    },
    insertCouponChange(val, item) {
      this.insertCouponShow = false;
      console.log("插入优惠劵返回==", val, item);
      if (val == true) {
        this.insertCouponValue = item.link;
      }
    },
    // 插入短链接隐藏 flag 为true 表示转为极短链接
    insertUrlChange(val, flag) {
      var isJdApi = 2; // 精准营销页面为2 调用京东接口
      var shortLinkType = 4;
      var isPrecision = 1; // 是否为精准营销
      var url = "";
      var url2 = "";
      var isSmartLink = 0; // 自家平台可以传，是否为智能链接 1.是 自家平台 0.极短链接 其他为空
      var strategyInstId = this.strategyInstId;
      var originUrl =
        // "https://h5.m.jd.com/dev/RLVegkgjdNJoM4Y1WsvAnKLD7Qw/index.html?appurl=";
        "";
      if (!flag) {
        if (this.typeSms == "3") {
          isSmartLink = 1;
        } else {
          isSmartLink = "";
        }
      }
      if (this.insertUrlValue2) {
        this.insertUrlValue2 = this.insertUrlValue2.trim();
      }
      if (this.insertUrlValue3) {
        this.insertUrlValue3 = this.insertUrlValue3.trim();
      }
      // 生成网址
      if (val == 1) {
        // var url = '/(^#)|(^http(s*):\/\/[^\s]+\.[^\s]+)/';
        shortLinkType = 1;
        url = this.insertUrlValue;
      } else if (val == 2) {
        shortLinkType = 4;
        // 其他页面
        // url = originUrl + encodeURIComponent(this.insertUrlValue2);
        url = originUrl + this.insertUrlValue2;
        if (val == 2) {
          // 店铺首页
          // url = originUrl + encodeURIComponent(this.shopHomeUrl);
          url = originUrl + this.shopHomeUrl;
          // url = originUrl + this.shopHomeUrl;
        }
      } else if (val == 3) {
        // 商品链接
        shortLinkType = 3;
        url =
          originUrl +
          // encodeURIComponent("https://item.m.jd.com/product/") +
          "https://item.m.jd.com/product/" +
          this.insertUrlValue2 +
          ".html";
      } else if (val == 4) {
        // 优惠券
        shortLinkType = 4;
        url = this.insertCouponValue;
      } else if (val == 5) {
        shortLinkType = 4;
        url = originUrl + this.insertUrlValue3;
        if (val == 2) {
          url = originUrl + this.shopHomeUrl;
        }
      }
      url2 = url;

      if (val == 2 || val == 3 || val == 5) {
        // 店铺首页，商品链接， 其他页面
        if (url.indexOf("?") != "-1") {
          url += "&ad_od=1";
        } else {
          url += "?ad_od=1";
        }
      }

      if (this.typeSms == "1") {
        isJdApi = 2; // 官方
        isPrecision = 0;
      } else if (this.typeSms == "2") {
        isJdApi = 2; // 官方
        isPrecision = 0;
      } else {
        isJdApi = 1; // 平台
        isPrecision = 0;
      }

      var param = {
        isJdApi,
        url,
        shortLinkType,
        isSmartLink,
        isPrecision,
        strategyInstId,
      };
      // this.show = false;
      if (flag) {
        this.shortLoading = true;
      } else {
        this.loading = true;
      }
      getShortLink(param).then((res) => {
        if (flag) {
          this.shortLoading = false;
        } else {
          this.loading = false;
        }

        console.log("res==", res);
        if (res.code == "1") {
          console.log("res.data.shortLink:", res.data);
          res.data.originUrl = url;
          res.data.originUrl2 = url2;
          res.data.param = param
          this.$emit("close", true, res.data);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.insertBox {
  text-align: right;
  .inser {
    display: flex;
    align-items: center;
    margin-top: 20px;
  }
  .insert {
    text-align: left;
    margin-top: 20px;
    .insert-name {
      display: inline-block;
      width: 88px;
      margin-right: 8px;
      vertical-align: text-top;
      line-height: 32px;
    }
    .insert-value {
      display: inline-block;
      width: 400px;
      vertical-align: text-top;
    }
  }
  .insertLink {
    margin-top: 20px;
    .short-bottom {
      display: flex;
      margin-left: 40px;
      .edit_btn {
        color: #7f85e9;
        width: auto;
        &:hover {
          color: #fe4d45;
        }
      }
    }
    /deep/ .el-textarea {
      width: 407px;
      .el-textarea__inner {
        height: 80px !important;
      }
}
  }
  .right-dis {
    margin-right: 10px;
  }
  .cancelBtn {
    margin-right: 10px;
    width: 98px;
    height: 32px;
    color: #666666;
    border-radius: 3px;
    border: 1px solid #dddddd;
    background-color: #fff;
    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
    &:active {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
  .createUrlBtn {
    width: 98px;
    height: 32px;
    line-height: 30px;
    margin-top: 20px;
    text-align: center;
    background: rgba(254, 77, 69, 1);
    border-radius: 3px;
    color: #fff;
    font-size: 14px;
    &:hover {
      background: #fe4d45;
      opacity: 0.9;
    }
  }
  button {
    border: none;
    background-color: white;
    outline: none;
    padding: 0;
    margin: 0;
    border-radius: 2px;
  }
  .tip_box {
    padding-left: 50px;
    text-align: left;
    line-height: 21px;
    font-size: 14px;
    margin-top: 12px;
    color: #999999;
    position: relative;
    .warning-icon {
      color: #fe8f8a;
      font-size: 14px;
      position: absolute;
      left: 5px;
      top: 4px;
    }
  }
}

.tab-line {
  .tab-item {
    display: inline-block;
    width: 80px;
    line-height: 32px;
    background: rgba(250, 250, 250, 1);
    border: 1px solid rgba(238, 238, 238, 1);
    text-align: center;
    border-radius: 4px;
    margin-top: 20px;
    cursor: pointer;
    margin-right: 8px;
    font-size: 14px;
    color: #333;
  }
}


/deep/ .el-dialog__wrapper {
  z-index: 999999 !important;
  /deep/ .el-dialog {
      z-index: 999999 !important;
    }
  }
</style>
